import Image from 'app/Components/Shared/Image/image';
// BreadCrumbsBlock.tsx
import React, { ReactNode } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BreadCrumbsBlockData, { BreadCrumbsBlockProps } from 'app/Models/Content/BreadCrumbsBlockData';
import './BreadCrumbsBlock.scss';
const purpleStarImg = require('./images/purple-star.svg');

export default class BreadCrumbsBlock extends EpiComponent<BreadCrumbsBlockData> {
  public render(): ReactNode {
    const blockData = this.props.data;
    const links = blockData.links?.value || [];
    const showPurpleStart = blockData.showPurpleStart?.value || false;

    console.log("BreadCrumbsBlock data:", blockData);
    console.log("Links value:", links);
    console.log("Show purple start:", showPurpleStart);

    return (
      <div className="BreadCrumbsBlock" style={this.getBlockStyles()}>
          {links && links.length > 0 ? (
            <>
            {/* Desktop version - unchanged */}
            <div aria-label="Breadcrumbs" className="breadcrumb-trail desktop-only">
              {[...links].reverse().map((link: any, index: number) => {
                const href = link.href || link.url || "#";
                const text = link.text || link.title || href;
                const title = link.title;
                const target = link.target;
                const isExternal = typeof href === "string" && /^https?:\/\//i.test(href);
                const finalTarget = target || (isExternal ? "_blank" : undefined);
                const rel = finalTarget === "_blank" ? "noopener noreferrer" : undefined;
                const isLastLink = index === 0;
                const linkClasses = `breadcrumb-link ${isLastLink ? 'breadcrumb-link-last' : ''}`;
                const showSeparator = index !== 0;

                return (
                  <span key={index}>
                    {showSeparator && <span className="breadcrumb-separator"> {'< '} </span>}
                    <a href={href} title={title} target={finalTarget} rel={rel} className={linkClasses} dir="auto">
                      {text}
                    </a>
                  </span>
                );
              })}

              {showPurpleStart && (
                <>
                  {links.length > 0 && <span className="breadcrumb-separator"> {'< '} </span>}
                  <span>
                    <a href="/" title="Home" className="purple-star-link">
                      <Image src={purpleStarImg} alt="Home" className="purple-star-icon" />
                    </a>
                  </span>
                </>
              )}
            </div>

            {/* Mobile version - wraps automatically */}
            <div aria-label="Breadcrumbs" className="breadcrumb-trail mobile-only">
              {showPurpleStart && (
                <div className="star-container">
                  {links.length > 0 && <span className="breadcrumb-separator"> {'< '} </span>}
                  <a href="/" title="Home" className="purple-star-link">
                    <Image src={purpleStarImg} alt="Home" className="purple-star-icon" />
                  </a>
                </div>
              )}

              <div className="links-container">
                {[...links].map((link: any, index: number) => {
                  const href = link.href || link.url || "#";
                  const text = link.text || link.title || href;
                  const title = link.title;
                  const target = link.target;
                  const isExternal = typeof href === "string" && /^https?:\/\//i.test(href);
                  const finalTarget = target || (isExternal ? "_blank" : undefined);
                  const rel = finalTarget === "_blank" ? "noopener noreferrer" : undefined;
                  const isLastLink = index === links.length - 1;
                  const linkClasses = `breadcrumb-link ${isLastLink ? 'breadcrumb-link-last' : ''}`;
                  const showSeparator = index !== links.length - 1;

                  return (
                    <span key={index}>
                      {showSeparator && <span className="breadcrumb-separator"> {'< '} </span>}
                      <a href={href} title={title} target={finalTarget} rel={rel} className={linkClasses} dir="auto">
                        {text}
                      </a>
                    </span>
                  );
                })}
              </div>
            </div>
            </>
          ) : (
          <div>
            <p>No links found in the CMS block.</p>
            <p><small>Make sure you've added links to the "Links" property in the CMS.</small></p>
          </div>
        )}
      </div>
    );
  }

  protected getBlockStyles(): React.CSSProperties {
    const blockData = this.props.data;
    return {
      backgroundColor: blockData.backgroundColor?.value || 'transparent',
      opacity: blockData.blockOpacity?.value || 1,
      margin: blockData.margin?.value || undefined,
      padding: blockData.padding?.value || undefined,
    };
  }
}
